import AgentProfilePage from '@/components/AgentProfilePage';
import ChatPage from '@/components/ChatPage';
import CreateAgentPage from '@/components/CreateAgentPage';
import DashboardHomePage from '@/components/DashboardHomePage';
import GPUNetworkPage from '@/components/GPUNetworkPage';
import HomePage from '@/components/HomePage';
import MarketplacePage from '@/components/MarketplacePage';
import RentGPUsPage from '@/components/RentGPUsPage';
import { Toaster } from '@/components/ui/sonner';
import { ThemeProvider } from '@/hooks/use-theme';
// import { OAuthProvider } from '@/contexts/OAuthContext';
import { JSX } from 'react';
import { Route, Routes } from 'react-router-dom';

function App(): JSX.Element {
  return (
    <ThemeProvider>
      {/* NOTE: UI Generator - Uncomment OAuthProvider wrapper below if OAuth functionality is needed.
          See .claude/skills/oauth/docs/implementation-guide.md for OAuth implementation guide. */}
      {/* <OAuthProvider> */}
      <div
        id='app-container'
        className='relative min-h-screen flex flex-col bg-background'
      >
        <main id='app-main' className='flex-1'>
          <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/app' element={<DashboardHomePage />} />
            <Route path='/home' element={<DashboardHomePage />} />
            <Route path='/agents' element={<MarketplacePage />} />
            <Route path='/agents/:agentId' element={<AgentProfilePage />} />
            <Route path='/agents/:agentId/chat' element={<ChatPage />} />
            <Route path='/dashboard' element={<DashboardHomePage />} />
            <Route path='/gpu-network' element={<GPUNetworkPage />} />
            <Route path='/rent' element={<RentGPUsPage />} />
            <Route path='/create' element={<CreateAgentPage />} />
            <Route path='/agents/:agentId/edit' element={<CreateAgentPage />} />
          </Routes>
        </main>

        <Toaster />
      </div>
      {/* </OAuthProvider> */}
    </ThemeProvider>
  );
}

export default App;
